import React from 'react';
import { Link } from 'react-router-dom';
import './live.css';

export default function LiveFrame({ back, backLabel, title, meta, actions, children }) {
  return (
    <div className="cs-page live-page" data-nova-note={`Live monitoring: ${title}${meta ? ` — ${meta}` : ''}. Read-only boards for a hosted instance or the fleet; NoVA explains them (instance_status, instance_costs, run_security_scan) and navigates back to DevOps.`.slice(0, 320)}>
      <p className="live-back"><Link to={back}>{backLabel}</Link></p>
      <div className="live-head">
        <div>
          <h1>{title}</h1>
          {meta ? <p className="cs-help">{meta}</p> : null}
        </div>
        {actions ? <div className="live-actions">{actions}</div> : null}
      </div>
      {children}
    </div>
  );
}

export function LiveSection({ title, meta, children }) {
  return (
    <section className="live-section">
      <div className="live-section-head">
        <h2>{title}</h2>
        {meta ? <span className="cs-help">{meta}</span> : null}
      </div>
      {children}
    </section>
  );
}
